import { proxy } from 'valtio';

// NOTE: Can't use the module types here. Circular dependency
// import { type EligibleAction } from '@canvas/module-types/ui/action';

export type EligibleAction = {
  id: string;
  type?: 'context-menu' | 'toolbar'; // this restricts it if it is set
};

export const currentEligibleActions: {
  actions: EligibleAction[];
} = proxy({
  actions: [],
});
